import React, { useState, useEffect } from 'react';
import './Projects.css'
import Carousel from './Carousel'


function Projects() {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [screenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY); // Update scroll position
    };

    window.addEventListener('scroll', handleScroll); // Listen to scroll event
    return () => window.removeEventListener('scroll', handleScroll); // Cleanup
  }, []);

  // Increase font size based on scroll position
  let fontSize = Math.min(7.9, 1 + scrollPosition / 100) + 'em';

   if (screenWidth <= 454) {
     fontSize = Math.min(7, 1 + scrollPosition / 80) + 'em';
   } else if(screenWidth <= 416) {
     fontSize = Math.min(7.4, 1 + scrollPosition / 60) + 'em';
   } else if (screenWidth <= 407) {
    fontSize = Math.min(7, 1 + scrollPosition / 40) + 'em';
  } else if (screenWidth <= 380) {
    fontSize = Math.min(6.6, 1 + scrollPosition / 20) + 'em';
  }
  

  return (
    <div style={{height: '95.3vh' }} className="test" id="project">
      <h1 style={{fontSize}} className="project-title">Projects</h1>
      <Carousel />
    </div>
  );
}

export default Projects;
